
        var result = require("!!../../../../node_modules/css-loader/index.js!./static-page.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/static-page/static-page.component.css
// module id = 630
// module chunks = 0